import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "creation__container" }
const _hoisted_2 = { class: "creation__content-wrapper creation__content-wrapper--form" }
const _hoisted_3 = { class: "creation__content" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-6" }
const _hoisted_5 = {
  key: 0,
  class: "pt-1"
}
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex-shrink-0 w-24 aspect-[3/4] flex items-center justify-center rounded-md border border-dashed border-creation-on-background border-opacity-creation-separator bg-creation-on-background/creation-circle1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", { class: "icon w-6 h-6 stroke-[1.5] text-creation-on-background text-opacity-creation-low" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#image" })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "flex-shrink-0 w-24 aspect-[3/4] rounded-md border border-black/10 bg-white overflow-hidden"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex flex-col gap-4" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "form__label" }
const _hoisted_15 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_16 = { class: "text-xs text-creation-on-background text-opacity-creation-high" }
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#trash" })
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "form__group"
}
const _hoisted_21 = { class: "form__label" }
const _hoisted_22 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 2,
  class: "form__group"
}
const _hoisted_25 = { class: "form__label" }
const _hoisted_26 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 1,
  class: "creation__content-wrapper"
}
const _hoisted_29 = { class: "creation__content items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-[72px] h-[72px] bg-creation-on-background/creation-separator flex justify-center items-center rounded-full flex-shrink-0 mb-4" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon w-10 h-10 stroke-2 text-creation-on-background text-opacity-creation-high" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#check" })
  ])
], -1)
const _hoisted_31 = { class: "text-xl font-semibold mb-5 text-center text-creation-on-background" }
const _hoisted_32 = { class: "border-t border-creation-on-background border-opacity-creation-separator pt-5 px-1 w-full" }
const _hoisted_33 = { class: "flex flex-col gap-6" }
const _hoisted_34 = { class: "px-4 py-2 xs:py-4 flex justify-between border-t border-creation-on-background border-opacity-creation-separator" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-left" })
], -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallHeaderComponent = _resolveComponent("SmallHeaderComponent")!
  const _component_ConsentsCheckboxesComponent = _resolveComponent("ConsentsCheckboxesComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.collectingDataEnabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_SmallHeaderComponent, {
            campaign: _ctx.campaign,
            promptText: _ctx.campaign.promptText
          }, null, 8, ["campaign", "promptText"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!this.isCollectImagesDisabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("input", {
                        id: "file-upload",
                        name: "file-upload",
                        type: "file",
                        class: "sr-only",
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFileBrowseSelected())),
                        ref: "fileSelector",
                        accept: "image/jpg,image/jpeg,image/png,image/*"
                      }, null, 544),
                      _createElementVNode("div", _hoisted_6, [
                        (!_ctx.contribution.imageURL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("img", {
                                class: "w-full h-full object-cover",
                                src: _ctx.contribution.imageURL
                              }, null, 8, _hoisted_11)
                            ])),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, [
                              _createTextVNode(_toDisplayString(_ctx.$t('creation.imageTitleLabel')), 1),
                              (_ctx.isCollectImagesRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('creation.imageDescriptionLabel')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", {
                              role: "button",
                              tabindex: "0",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openImageSelector && _ctx.openImageSelector(...args))),
                              class: "button button--small button--secondary"
                            }, _toDisplayString(_ctx.$t('creation.uploadImageButtonLabel')), 1),
                            (_ctx.contribution.imageURL)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  role: "button",
                                  tabindex: "0",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSelectedImage && _ctx.removeSelectedImage(...args))),
                                  class: "button button--small button--circle button--secondary"
                                }, _hoisted_19))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isCollectNamesDisabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, [
                        _createTextVNode(_toDisplayString(_ctx.$t('creation.nameInputFieldLabel')), 1),
                        (_ctx.isCollectNamesRequired)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
                        id: "name",
                        type: "text",
                        class: "form__input",
                        placeholder: _ctx.$t('creation.nameInputFieldPlaceholder')
                      }, null, 8, _hoisted_23), [
                        [_vModelText, _ctx.name]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isCollectEmailsDisabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, [
                        _createTextVNode(_toDisplayString(_ctx.$t('creation.emailInputFieldLabel')), 1),
                        (_ctx.isCollectEmailsRequired)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                        id: "email",
                        type: "email",
                        class: "form__input",
                        placeholder: _ctx.$t('creation.emailInputFieldPlaceholder')
                      }, null, 8, _hoisted_27), [
                        [_vModelText, _ctx.email]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ConsentsCheckboxesComponent, {
                  onTermsAndConditionsConsentGivenChanged: _ctx.termsAndConditionsConsentGivenChanged,
                  onPrivacyPolicyAcceptedChanged: _ctx.privacyPolicyAcceptedChanged,
                  termsAndConditionsConsentGiven: _ctx.termsAndConditionsConsentGiven,
                  privacyPolicyAccepted: _ctx.privacyPolicyAccepted,
                  campaign: _ctx.campaign
                }, null, 8, ["onTermsAndConditionsConsentGivenChanged", "onPrivacyPolicyAcceptedChanged", "termsAndConditionsConsentGiven", "privacyPolicyAccepted", "campaign"])
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('creation.anonymousLastScreenTitle')), 1),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_ConsentsCheckboxesComponent, {
                  onTermsAndConditionsConsentGivenChanged: _ctx.termsAndConditionsConsentGivenChanged,
                  onPrivacyPolicyAcceptedChanged: _ctx.privacyPolicyAcceptedChanged,
                  termsAndConditionsConsentGiven: _ctx.termsAndConditionsConsentGiven,
                  privacyPolicyAccepted: _ctx.privacyPolicyAccepted,
                  campaign: _ctx.campaign
                }, null, 8, ["onTermsAndConditionsConsentGivenChanged", "onPrivacyPolicyAcceptedChanged", "termsAndConditionsConsentGiven", "privacyPolicyAccepted", "campaign"])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("button", {
        class: "button button--circle button--large button--secondary",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToRecordingScreen && _ctx.goToRecordingScreen(...args)))
      }, _hoisted_36),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--large button--wider shadow bg-creation-primary text-creation-on-primary", { 'button--disabled': !_ctx.canSubmit }]),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.tryToSubmit && _ctx.tryToSubmit(...args)))
      }, _toDisplayString(_ctx.$t('creation.submitButtonLabel')), 3)
    ]),
    _createVNode(_component_FooterComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
  ]))
}